import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "custom-tree-node"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "选择运营点位",
    width: "620px",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.dialogVisible = $event)
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmHandler
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_tree, {
      "highlight-current": true,
      "check-on-click-node": false,
      "node-key": "id",
      class: "tree",
      props: $setup.defaultProps,
      "default-expanded-keys": _ctx.defaultExpandedeys,
      "current-node-key": '001',
      lazy: true,
      accordion: "",
      load: $setup.loadNode,
      ref: "treeRef"
    }, {
      default: _withCtx(({
        node
      }) => [_createElementVNode("span", _hoisted_1, [_createElementVNode("span", {
        title: node.label
      }, _toDisplayString(node.label), 9, _hoisted_2)])]),
      _: 1
    }, 8, ["props", "default-expanded-keys", "load"])]),
    _: 1
  }, 8, ["modelValue"]);
}